import React, { useState } from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import AppFonts from "../../Constants/AppFonts";

// Import your report screens
import DefaultReports from "../Report/DefaultReports";
import ScheduledReports from "../Report/ScheduledReports";
import CustomizedReports from "../Report/CustomizedReports";

const useTabNavigator = (initialTab = 0) => {
  const [activeTab, setActiveTab] = useState(initialTab);

  const tabs = [
    { id: "default", label: "Default Reports", component: DefaultReports },
    { id: "scheduled", label: "Scheduled", component: ScheduledReports },
    { id: "customized", label: "Customized", component: CustomizedReports },
  ];

  const TabBar = ({
    style,
    tabStyle,
    activeTabStyle,
    textStyle,
    activeTextStyle,
  }) => (
    <View style={[styles.tabBar, style]}>
      {tabs.map((tab, index) => (
        <TouchableOpacity
          key={tab.id}
          style={[
            styles.tab,
            tabStyle,
            activeTab === index && [styles.activeTab, activeTabStyle],
          ]}
          onPress={() => setActiveTab(index)}
        >
          <Text
            style={[
              styles.tabText,
              textStyle,
              activeTab === index && [styles.activeTabText, activeTextStyle],
            ]}
          >
            {tab.label}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );

  const TabContent = () => {
    const ActiveComponent = tabs[activeTab].component;
    return <ActiveComponent />;
  };

  return {
    TabBar,
    TabContent,
    activeTab,
    setActiveTab,
    tabs,
  };
};

const DrawerToptab = () => {
  const { TabBar, TabContent } = useTabNavigator();

  return (
    <View style={styles.container}>
      <TabBar
        style={styles.customTabBar}
        tabStyle={styles.customTab}
        activeTabStyle={styles.customActiveTab}
        textStyle={styles.customTabText}
        activeTextStyle={styles.customActiveTabText}
      />
      <View style={styles.content}>
        <TabContent />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#FFFFFF",
  },
  tabBar: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    borderBottomWidth: 1,
    borderBottomColor: "#F0F0F0",
    paddingHorizontal: 20,
  },
  tab: {
    flex: 1,
    paddingVertical: 16,
    alignItems: "center",
    justifyContent: "center",
    borderBottomWidth: 3,
    borderBottomColor: "transparent",
  },
  activeTab: {
    borderBottomColor: "#9C4900",
  },
  tabText: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: "#8F4300CC",
  },
  activeTabText: {
    fontFamily: AppFonts.OverpassBold,
    color: "#8F4300",
  },
  content: {
    flex: 1,
    padding: 20,
  },
  // Custom styles
  customTabBar: {
    elevation: 3,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
  },
  customTab: {
    marginHorizontal: 4,
  },
  customActiveTab: {
    backgroundColor: "#FFF9F2",
    borderRadius: 8,
    borderBottomWidth: 0,
    marginTop: 4,
  },
  customTabText: {
    fontSize: 13,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  customActiveTabText: {
    fontSize: 14,
  },
});

export default DrawerToptab;
